import React, { useState, useRef, useEffect } from 'react';
import { List, X } from 'lucide-react';

const SECTIONS = [
  { id: 'top', label: 'Top of Page' },
  { id: 'pillars', label: 'Experience \u2022 Professionalism \u2022 Unique' },
  { id: 'what-we-do', label: 'Types of Performances' },
  { id: 'services-columns', label: 'Staff \u2022 Services \u2022 Classes' },
  { id: 'book', label: 'Why Choose Us' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'clients', label: 'Some of Our Clients' },
];

export const HomeTableOfContents = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickAway = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickAway);
    return () => document.removeEventListener('mousedown', onClickAway);
  }, []);

  const jump = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div
      ref={ref}
      className="fixed left-2 md:left-3 top-24 md:top-28 z-40 flex flex-col items-start"
      data-testid="table-of-contents"
    >
      <button
        onClick={() => setOpen(o => !o)}
        aria-label="Table of contents"
        title="Table of Contents"
        className="flex flex-col items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95 leading-none"
        style={{
          background: 'linear-gradient(135deg, #4A006B 0%, #53AD22 100%)',
          color: '#F4E400',
          border: '2px solid #F4E400',
        }}
        data-testid="toc-toggle-btn"
      >
        {open ? (
          <X className="w-5 h-5 md:w-6 md:h-6" />
        ) : (
          <>
            <span className="text-[9px] md:text-[10px] font-black tracking-wider mt-0.5">TOC</span>
            <List className="w-4 h-4 md:w-5 md:h-5 mt-0.5" />
          </>
        )}
      </button>

      {open && (
        <div
          className="mt-2 w-64 max-h-[70vh] overflow-y-auto rounded-xl shadow-2xl border-2"
          style={{ background: 'rgba(15, 10, 25, 0.96)', borderColor: '#53AD22', backdropFilter: 'blur(8px)' }}
          data-testid="toc-menu"
        >
          <div
            className="px-4 py-2 text-[11px] font-bold uppercase tracking-widest border-b border-white/10"
            style={{ color: '#F4E400' }}
          >
            Table of Contents
          </div>
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              onClick={() => jump(s.id)}
              className="block w-full text-left px-4 py-2.5 text-xs md:text-sm font-semibold text-white hover:bg-white/10 transition-colors border-b border-white/10 last:border-b-0"
              data-testid={`toc-link-${s.id}`}
            >
              <span style={{ color: '#F4E400', marginRight: 8 }}>{'\u25B8'}</span>
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
